import script from "./imageView.vue?vue&type=script&setup=true&lang=js"
export * from "./imageView.vue?vue&type=script&setup=true&lang=js"

import "./imageView.vue?vue&type=style&index=0&id=299851c4&lang=less&scoped=true"

import exportComponent from "D:\\workspaceJava\\wlyc\\wlyc\\tianjing-client-web-develop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-299851c4"]])

export default __exports__